import { Component, HostBinding, Input } from "@angular/core";
import { Observable } from "rxjs";
import { Store, select } from "@ngrx/store";
import { ThemeOptions } from "../../../theme-options";
import { CrudService } from "src/app/Services/crud.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  standalone: false,
})
export class HeaderComponent {
  @Input() signin: any;
  data;
  public config$: Observable<any>;
  constructor(
    public globals: ThemeOptions,
    private router: Router,
    private crudService: CrudService,
    private route: ActivatedRoute,
    private store: Store<{ config: any }>
  ) {
    this.config$ = this.store.pipe(select("config"));
  }

  ngOnInit() {
    if (!this.signin) {
      this.fetchExpiryDate();
    }
  }

  @HostBinding("class.isActive")
  get isActiveAsGetter() {
    return this.isActive;
  }

  isActive: boolean;

  // @select("config") public config$: Observable<any>;

  toggleSidebarMobile() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
  }

  toggleHeaderMobile() {
    this.globals.toggleHeaderMobile = !this.globals.toggleHeaderMobile;
  }

  gotodashboard() {
    this.router.navigate(["/page/dashboard"]);
  }

  fetchExpiryDate() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        // console.log("response for expirydate", response);
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.data = null;
        } else {
          self.data = response;
        }
      },
      "licenseHistories/getExpiryInfo"
    );
  }
}
